"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Chip_1 = __importDefault(require("@material-ui/core/Chip"));
const useStyles = styles_1.makeStyles((theme) => ({
    blue: {
        backgroundColor: theme.palette.info.dark,
        color: theme.palette.info.contrastText,
    },
    grey: {
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.info.contrastText,
    },
    green: {
        backgroundColor: theme.palette.success.dark,
        color: theme.palette.success.contrastText,
    },
    red: {
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
    },
}));
/**
 * A badge is a small color-coded visual element, containing letters or numbers, that you can use to label, categorize or organize items.
 */
const Badge = (_a) => {
    var { color = 'grey', content } = _a, props = __rest(_a, ["color", "content"]);
    const classes = useStyles();
    return react_1.default.createElement(Chip_1.default, { className: classes[color], label: content, "data-testid": props['data-testid'] });
};
exports.default = Badge;
//# sourceMappingURL=index.js.map